import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
/** Services Import */
import Commons from "../../../Services/Common/Common";
import Dialog from "../../../Services/Common/Dialog";
import Global from "../../../Services/Common/Global";
import IndexedDb from "../../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Snackbar from "../../../Components/Snackbar";
/** Drawer Import */
import { DrawerActions } from "../../../Reducers/DrawerReducer";
import GridModal from "../../../Components/Modal_Grid";
import FormGroup from "../../../Components/Form_Group";
import BasicModal from "../../../Components/Modal_Basic";
import Checking from "../../../Components/Checking";
import { common } from "@mui/material/colors";
import axios from "axios";
function Topbar() {
  const [lanData, setLanData] = React.useState([]);

  const navigate = useNavigate(); // Route move api
  const dispatch = useDispatch(); // Dispatch 사용을 위한 저장
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const drawerStates = useSelector((state) => state.Drawer); // Drawer Redux 호출
  const [loginInfo, setLoginInfo] = React.useState("");
  const [userId, setUserId] = React.useState("");
  const [modalToggle, setModalToggle] = React.useState(false);
  const [inputs, setInputs] = React.useState({
    psw: "",
    pswCheck: "",
    currentPsw: "",
  });
  const [useOk, setUseOk] = React.useState(true);
  React.useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        setLoginInfo(result.userNm);
        setUserId(result.userId);
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const logout = async () => {
    let aside = document.querySelector(".aside");
    aside.style.display = "none";
    let userInfo = {};

    dispatch(DrawerActions.closeMobileMenuToggle());
    Commons.Storages("set", "authorization", {
      authorization: false,
      authDate: Commons.DateFormating(new Date()),
    });
    navigate("/");
    try {
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Common.LogOut,
        {
          userId: userId,
        }
      ).then((result) => {
        let data = result.data;
        IndexedDb.ClearDb("LoginInfo");
      });
    } catch (e) {}
  };

  const checkPsw = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    let getData = [];
    // let mySalt = "$2a$13$/8Wncr26eAmxD1l6cAF9F8";
    // let passwordHash = bcrypt.Net.BCrypt.HashPassword(
    //   inputs.currentPsw,
    //   mySalt
    // );
    // console.log(passwordHash);
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.CheckPassword,
        {
          password: inputs.currentPsw,
          userId: userInfo.userId,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          // } else if (data[0].password !== passwordHash) {
          //   throw new Error("지난비번이 다름");
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: "사용가능한 비밀번호 입니다.",
          });
          setUseOk(false);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const SavePsw = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    let getData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Common.SavePassword,
        {
          userId: userInfo.userId,
          password: inputs.psw,
          userNm: "string",
          createDate: new Date(),
          createId: "string",
          updateDate: new Date(),
          updateId: userInfo.userId,
          useYn: "Y",
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (inputs.psw !== inputs.pswCheck) {
          throw new Error("비밀번호가 다릅니다.");
        } else if (!inputs.psw) {
          throw new Error("비밀번호를 입력해주세요.");
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: "비밀번호가 변경되었습니다.",
          });
          setUseOk(false);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  return (
    <header id="header" className="header">
      <div className="inner">
        <a
          className="logo"
          id="logo"
          onClick={() => {
            navigate("/Home");
            dispatch(DrawerActions.setAppBarLTitle("Home"));
            dispatch(DrawerActions.setAppBarMTitle(""));
          }}
        >
          DongSungPrinting
        </a>
        <div className="util">
          <div className="hello with_icon">
            <span className="icon_user"></span>
            <p>
              <strong>{loginInfo + "님"}</strong>
              <span>반갑습니다!</span>
            </p>
          </div>
          <button
            type="button"
            className="btn_password"
            onClick={() => {
              setModalToggle(true);
            }}
          >
            <span>비밀번호변경</span>
          </button>{" "}
          <button
            type="button"
            className="btn_logout"
            onClick={() => {
              dispatch(DrawerActions.setAppBarLTitle("Home"));

              dispatch(DrawerActions.setAppBarMTitle(""));
              logout();
            }}
          >
            <span>로그아웃</span>
          </button>
        </div>
        {!drawerStates.mobileMenuToggle && (
          <button
            type="button"
            id="btnMenu"
            aria-label="메뉴 열기"
            onClick={() => {
              let aside = document.querySelector(".aside");
              aside.style.display = "block";
              dispatch(DrawerActions.openMobileMenuToggle());
            }}
          />
        )}
      </div>
      <div
        className="page_title"
        id="topbar"
        // style={{
        //   width: "200px",
        //   display: "flex",
        //   alignItems: "center",
        // }}
      >
        {/* <h1>
          <span className="bullet" />
          <strong className="depth-1">{drawerStates.appBarLTitle}</strong>
          <span className="divider" />
          <strong>{drawerStates.appBarMTitle}</strong>
        </h1> */}
      </div>
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
      {modalToggle && (
        <BasicModal
          name={
            "비밀번호변경" //그룹권한
          }
          onClose={() => {
            setInputs({
              currentPsw: "",
              psw: "",
              pswCheck: "",
            });
            setModalToggle(false);
          }}
          buttonName1={
            "변경" //검사
          }
          // disable={useOk}
          execLogic={(e) => {
            SavePsw();
            setUseOk(true);
          }}
          // buttonName4={"체크"}
          // checkLogic={(e) => {
          //   checkPsw();
          // }}
        >
          <Checking
            datas={[
              // {
              //   name: "기존 비밀번호",
              //   type: "password",
              //   value: inputs.currentPsw,
              //   onChange: (e) => {
              //     setInputs({
              //       ...inputs,
              //       currentPsw: e.target.value,
              //     });
              //   },
              //   containerStyle: { justifyContent: "start" },
              // },
              {
                name: "새 비밀번호 입력",
                type: "password",
                value: inputs.psw,
                onChange: (e) => {
                  setInputs({
                    ...inputs,
                    psw: e.target.value,
                  });
                },
                containerStyle: { justifyContent: "start" },
              },
              {
                name: "새 비밀번호 확인",
                type: "password",
                value: inputs.pswCheck,
                onChange: (e) => {
                  setInputs({
                    ...inputs,
                    pswCheck: e.target.value,
                  });
                },
                containerStyle: { justifyContent: "start" },
              },
            ]}
          />
        </BasicModal>
      )}
    </header>
  );
}

export default Topbar;
